/**
 * Ensures at most one inline preview entity dialog is open without lifting state
 * to the page (which would re-render every mention in the document).
 */
let activeSession = null;

/**
 * @param {string} sessionKey - Stable per-mention id (uid preferred)
 * @param {() => void} onClose - Closes this mention's dialog
 */
export function activatePreviewEntityDialog(sessionKey, onClose) {
    if (!sessionKey || typeof onClose !== 'function') return;
    if (activeSession && activeSession.key !== sessionKey) {
        activeSession.onClose();
    }
    activeSession = {key: sessionKey, onClose};
}

/**
 * @param {string} sessionKey
 */
export function deactivatePreviewEntityDialog(sessionKey) {
    if (activeSession?.key === sessionKey) {
        activeSession = null;
    }
}

/** @internal test helper */
export function resetPreviewEntityDialogCoordinator() {
    activeSession = null;
}
